import moment from 'moment';

export const getDates = (startDate: string, endDate: string) => {
  const dateArray = [];
  let start = moment(startDate);
  const stop = moment(endDate);
  while (start <= stop) {
    dateArray.push(moment(start).format('YYYY-MM-DD'));
    start = moment(start).add(1, 'months');
  }
  return dateArray;
};

export const getUserInitials = (username: string) => {
  const names = username.split(' ');
  let initials = names[0].substring(0, 1).toUpperCase();

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
};
